module.exports = __webpack_public_path__ + "resources/img/sp_marketplace_m.41f175c034f0609d091864b48048840c.png";